export enum CompanyPrefixesField {
	Id = 'Id',
	Value = 'Value',
}
